module.exports = __webpack_public_path__ + "static/media/Governor House.e80ab712.mp3";